<template>
  <div class="card-container">
    <p class="currentTatName">当前机构：{{ organInfo.tatName }}</p>
    <common-top-form
      :model="formModel"
      :submitService="submitService"
      :submitData="submitData"
      @success="onSuccess"
      @openAddDialog="openAddDialog"
      addShowPower="/tatinfo/add"
    >
      <el-form-item label="商品名称">
        <el-input
          type="text"
          maxlength="20"
          v-model="formModel.goodsName"
          placeholder="请输入类别名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品类型">
        <el-select v-model="formModel.goodsType">
          <el-option
            v-for="item in TopGoodsTypes"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类别">
        <el-select v-model="formModel.goodsCategory">
          <el-option
            v-for="item in topCategoryname"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="goodsAlias"
        label="商品别名"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <!-- <el-table-column
        prop="goodsDesc"
        label="商品描述"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p v-html="scope.row.goodsDesc"></p>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="goodsName"
        label="商品名称"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="goodsType"
        label="商品类型"
        min-width="100"
        :formatter="formatterTableGoodsType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="categoryName"
        label="商品类别"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="needIntegral"
        label="所需积分"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="conversionMoney"
        label="金额"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="conversionCount"
        label="库存数量（个）"
        min-width="120"
        :formatter="formatterTableData"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="status"
        label="状态"
        min-width="100"
        :formatter="formatterTableData"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p>{{ scope.row.status == 1 ? "已发版" : "下架" }}</p>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="160">
        <template slot-scope="scope">
          <!-- <el-button type="text" @click="openAddDialog(scope.row)"
            >修改</el-button
          > -->
          <el-button type="text" @click="openAddDialog(scope.row)"
            >修改
          </el-button>
          <el-button type="text" @click="handleDelete(scope.row)"
            >删除</el-button
          >
          <el-button type="text" @click="handleStatus(scope.row)">{{
            scope.row.status == 0 ? "发布" : "下架"
          }}</el-button>
        </template>
      </el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      :formDialogTitle="itemId ? '修改' : '添加'"
      :model="dialogModel"
      :submitData="dialogData"
      :rules="dialogRules"
      :dialogService="dialogService"
      @close="dialogClose"
      @success="dialogSuccess"
      class="note"
    >
      <el-form-item label="商品别名" prop="goodsAlias">
        <el-input
          type="text"
          maxlength="20"
          :disabled="dialogModel.extraInfo != ''"
          v-model="dialogModel.goodsAlias"
          placeholder="请输入商品别名"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品类型" prop="goodsType">
        <el-select v-model="dialogModel.goodsType" @change="selectChanged(1)">
          <el-option
            v-for="item in GoodsTypes"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品类别" prop="goodsCategory">
        <el-select v-model="dialogModel.goodsCategory" @change="shoptypes">
          <el-option
            v-for="item in categoryname"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品名称" prop="goodsId">
        <el-select v-model="dialogModel.goodsId">
          <el-option
            v-for="item in GoodsListAll"
            :key="item.id"
            :label="item.goodsName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="会员级别"
        prop="extraInfo"
        v-if="dialogModel.showType == 1"
      >
        <el-select v-model="dialogModel.extraInfo">
          <el-option
            v-for="item in levelList"
            :key="item.id"
            :label="item.levelName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="卓越级别"
        prop="extraInfo"
        v-if="dialogModel.showType == 2"
      >
        <el-select v-model="dialogModel.extraInfo">
          <el-option
            v-for="item in seatList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所需积分" prop="needIntegral">
        <el-input-number
          v-model="dialogModel.needIntegral"
          :min="0"
          :max="999999999"
          :step="1"
          :precision="0"
          :controls="false"
        ></el-input-number>
      </el-form-item>
      <el-form-item label="数量" prop="startNumber" v-if="shopName == '通证'">
        <el-input
          type="text"
          maxlength="10"
          v-model="dialogModel.startNumber"
          placeholder="请输入数量"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="兑换金额"
        prop="conversionMoney"
        v-if="shopName == '现金'"
      >
        <el-input-number
          v-model="dialogModel.conversionMoney"
          :min="0"
          :max="999999999"
          :step="1"
          :precision="2"
          :controls="false"
        ></el-input-number>
      </el-form-item>
      <el-form-item
        label="库存"
        prop="conversionCount"
        v-if="shopName == '现金'"
      >
        <el-input
          type="text"
          maxlength="10"
          v-model="dialogModel.conversionCount"
          placeholder="请输入库存数量"
        ></el-input>
      </el-form-item>
      <el-form-item label="商品图片" prop="pictureUrl">
        <el-upload
          class="avatar-uploader"
          :action="uploadUrl + '8883/picture/upload'"
          :data="commonParams"
          name="picture"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img
            v-if="dialogModel.pictureUrl"
            :src="dialogModel.pictureUrl"
            class="avatar"
          />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="商品描述" prop="goodsDesc">
        <el-input
          v-model="dialogModel.goodsDesc"
          maxlength="80"
          show-word-limit
          type="textarea"
          resize="none"
          rows="5"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import FormDialog from "../../dialog/FormDialog";
import Server from "common/conf/Server";

import MallService from "service/MallService";
import MemberLevelService from "service/MemberLevelService";
import TimeRange from "service/constant/TimeRange";
import privateKey from "service/constant/privateKey";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "PublicPlatoonGoods",
  components: {
    CommonTopForm,
    CommonTable,
    FormDialog,
  },
  data() {
    const blurText = async (rule, value, callback) => {
      const boolean = new RegExp("^[1-9][0-9]*$").test(value);
      if (!boolean) {
        this.dialogRules.conversionCount[0].message = "请输入正整数";
        this.this.dialogModel.conversionCount = "";
      }
    };
    return {
      uploadUrl: Server[process.env.NODE_ENV],
      formModel: {
        goodsCategory: "",
        goodsType: "",
        goodsName: "",
      },
      tableData: [],
      submitService: MallService.publicplatoongoodsList,
      page: {},
      organInfo: {},
      isPage: false,
      itemId: "",
      dialogModel: {
        goodsAlias: "",
        goodsCategory: "",
        goodsDesc: "",
        goodsType: "",
        needIntegral: "",
        pictureUrl: "",
        goodsId: "",
        extraInfo: "",
        showType: "",
        startNumber: "",
        conversionMoney: "",
        conversionCount: "",
      },
      dialogRules: {
        goodsId: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请选择商品名称"));
              } else {
                this.GoodsListAll.forEach((item) => {
                  if (item.id == value) {
                    this.dialogModel.showType = item.showType;
                  }
                });
                return callback();
              }
            },
          },
        ],
        extraInfo: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    `请选择${
                      this.dialogModel.showType == 1 ? "会员" : "卓越"
                    }级别`
                  )
                );
              } else {
                return callback();
              }
            },
          },
        ],
        goodsAlias: [
          {
            required: true,
            message: "请输入商品别名",
          },
        ],
        goodsCategory: [
          {
            required: true,
            message: "请输入商品类别",
          },
        ],
        goodsDesc: [
          {
            required: true,
            message: "请输入商品描述",
          },
        ],
        goodsType: [
          {
            required: true,
            message: "请输入商品类型",
          },
        ],
        needIntegral: [
          {
            required: true,
            message: "请输入所需积分",
          },
        ],
        pictureUrl: [
          {
            required: true,
            message: "请上传商品图片",
          },
        ],
        // startNumber: [
        //   {
        //     required: true,
        //     message: "请输入商品数量",
        //   },
        // ],
        conversionMoney: [
          {
            required: true,
            message: "请输入兑换金额",
          },
        ],
        conversionCount: [
          {
            required: true,
            message: "请输入库存数量",
            validator: blurText,
          },
        ],
      },
      topCategoryname: [],
      categoryname: [],
      GoodsTypes: [],
      GoodsListAll: [],
      levelList: [],
      seatList: [],
      TopGoodsTypes: [],
      isFlag: false,
      shopName: "",
    };
  },
  inject: ["reload"],
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  mounted() {
    this.load();
  },
  computed: {
    commonParams() {
      const params = {
        serverType: this.serverType,
        tatId: this.tatId,
        reqTime: new Date().format("yyyy-MM-dd HH:mm:ss"),
      };
      params.sign = encrypt(
        urlEncode(objKeySort(params)) + "&priKey=" + privateKey.priKey
      );
      return params;
    },
    submitData() {
      this.params = {
        goodsCategory: this.formModel.goodsCategory,
        goodsName: this.formModel.goodsName,
        goodsType: this.formModel.goodsType,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
        simpleTatId: this.organInfo.id,
      };

      return this.params;
    },
    dialogData() {
      const params = {
        goodsAlias: this.dialogModel.goodsAlias,
        startNumber: this.dialogModel.startNumber,
        conversionCount: this.dialogModel.conversionCount,
        conversionMoney: this.dialogModel.conversionMoney,
        goodsCategory: this.dialogModel.goodsCategory,
        goodsDesc: this.dialogModel.goodsDesc,
        goodsType: this.dialogModel.goodsType,
        goodsId: this.dialogModel.goodsId,
        needIntegral: this.dialogModel.needIntegral,
        pictureUrl: this.dialogModel.pictureUrl,
        showType: this.dialogModel.showType,
        extraInfo: this.dialogModel.extraInfo,
        simpleTatId: this.organInfo.id,
      };
      if (this.itemId) {
        params.id = this.itemId;
      }
      return params;
    },
    dialogService() {
      return this.itemId
        ? MallService.publicplatoongoodsEdit
        : MallService.publicplatoongoodsAdd;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  watch: {
    //查询条件联动调动接口
    "formModel.goodsType"(val, oldVal) {
      this.getCategoryname(val);
      this.formModel.goodsCategory = ""; //商品类别
    },
    //商品类型
    "dialogModel.goodsType"(val, oldVal) {
      this.getCategoryname(val);
      // if (this.isFlag) {
      //   this.dialogModel.goodsCategory = ""; //商品类别
      //   this.dialogModel.goodsName = ""; //商品名称
      // }
    },
    "dialogModel.goodsCategory"(val, oldVal) {
      this.getGoodsListAll(val);
      this.formModel.goodsName = "";
    },
    "dialogModel.goodsId"(val, oldVal) {
      this.formModel.goodsAlias = "";
      this.formModel.extraInfo = "";
    },
    "dialogModel.extraInfo"(val, oldVal) {
      if (this.dialogModel.showType == 1) {
        this.dialogModel.goodsAlias = this.levelList.find(
          (item) => item.id == val
        ).levelName;
      }
      if (this.dialogModel.showType == 2) {
        this.dialogModel.goodsAlias = this.seatList.find(
          (item) => item.id == val
        ).name;
      }
    },
  },
  methods: {
    getSeatList() {
      this.doLoad(
        MemberLevelService.listNoPage,
        {
          tatSimpleId: this.organInfo.id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.seatList = result;
          });
        },
        "信息获取失败"
      );
    },
    getLevelList() {
      this.doLoad(
        MemberLevelService.select,
        {
          tatSimpleId: this.organInfo.id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            const result = res.contents;
            this.levelList = result.memLevelManageList;
          });
        },
        "信息获取失败"
      );
    },
    handleAvatarSuccess(res, file) {
      this.doCheck(res, (res) => {
        this.dialogModel.pictureUrl = res.contents;
      });
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    load() {
      this.organInfo = JSON.parse(this.$route.params.item);
      this.formModel = {
        goodsCategory: "",
        goodsType: "",
        goodsName: "",
      };

      this.page = this.$refs.commonTable.page;

      this.getGoodsTypes();
      this.getSeatList();
      this.getLevelList();
      this.getList();
    },
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getCategoryname(val) {
      this.doLoad(
        MallService.categoryname,
        {
          commodityType: val,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.isFlag = false;
            this.topCategoryname = [
              {
                id: "",
                categoryName: "全部",
              },
              ...res.contents,
            ];
            this.categoryname = res.contents;
          });
        },
        "操作失败"
      );
    },
    getGoodsTypes() {
      this.doLoad(
        MallService.goodsDictGoodsTypes,
        "",
        (res) => {
          this.doCheck(res, (res) => {
            this.TopGoodsTypes = [
              {
                id: "",
                name: "全部",
              },
              ...res.contents,
            ];
            this.GoodsTypes = res.contents;
          });
        },
        "操作失败"
      );
    },
    getGoodsListAll(val) {
      this.doLoad(
        MallService.storeGoodsListAll,
        {
          goodsCategory: val,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.GoodsListAll = res.contents;
          });
        },
        "操作失败"
      );
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    shoptypes(val) {
      this.categoryname.forEach((item) => {
        if (val == item.id) {
          this.shopName = item.categoryName;
        }
      });
      // this.dialogModel.goodsId = ""; //商品名称
      this.dialogModel.startNumber = 0; //数量
      this.dialogModel.conversionMoney = 0; //兑换金额
      this.dialogModel.conversionCount = 0; //库存
    },
    onSuccess(res) {
      this.doCheck(res, (res) => {
        const result = res.contents;
        this.tableData = result.rows;

        this.page.currentPage = result.current;
        this.page.total = result.total;
        this.page.pageSize = result.size;
      });
    },
    formatterTableGoodsType(row, column, cellValue, index) {
      let value = "";
      this.GoodsTypes.forEach((item) => {
        if (item.id == cellValue) {
          value = item.name;
        }
      });

      return value ? value : "--";
    },
    handleDelete(item) {
      this.showConfirm("确定删除该类别？")
        .then(() => {
          this.doDelete(item.id);
        })
        .catch(() => {});
    },
    doDelete(id) {
      this.doLoad(
        MallService.publicplatoongoodsDel,
        {
          id: id,
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    handleStatus(item) {
      this.showConfirm(`确定${item.status == 0 ? "发布" : "下架"}该类别？`)
        .then(() => {
          this.doStatus(item);
        })
        .catch(() => {});
    },
    doStatus(item) {
      this.doLoad(
        MallService.publicplatoongoodsUdpStatus,
        {
          id: item.id,
          status: item.status == 0 ? "1" : "0",
        },
        (res) => {
          this.doCheck(res, (res) => {
            this.commonSuccess(res);
          });
        },
        "操作失败"
      );
    },
    openAddDialog(item) {
      this.$router.push({
        name: "platformintroductionedit",
        params: {
          item: JSON.stringify(item),
          fuID: JSON.stringify(this.organInfo),
        },
      });
      this.itemId = item ? item.id : "";
      // if (this.itemId) {
      //   this.dialogModel = JSON.parse(JSON.stringify(item));
      //   this.dialogModel.goodsType = Number(this.dialogModel.goodsType);
      //   this.dialogModel.extraInfo = Number(this.dialogModel.extraInfo);
      //   this.shopName = this.dialogModel.categoryName;
      // }
      // this.$refs.formDialog.open();
    },
    dialogSuccess(res) {
      this.commonSuccess(res);
      this.$refs.formDialog.closeDialog();
    },
    dialogClose() {
      this.dialogModel = {
        goodsAlias: "",
        goodsCategory: "",
        goodsDesc: "",
        goodsType: "",
        needIntegral: "",
        pictureUrl: "",
        goodsName: "",
        extraInfo: "",
        showType: "",
        conversionMoney: "",
        conversionCount: "",
        startNumber: "",
      };
    },
    commonSuccess(res) {
      this.showSuccess(res.respMsg);
      this.getList();
    },
    selectChanged(val) {
      if (val == 1) {
        this.dialogModel.goodsCategory = ""; //商品类别
        // this.dialogModel.goodsId = ""; //商品名称
      }
    },
  },
};
</script>

<style scoped>
.currentTatName {
  margin-bottom: 30px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
  border: 1px solid #d9d9d9;
}

.iconUrl {
  width: 50px;
  height: 50px;
  margin: auto;
  overflow: hidden;
}
/deep/ .el-table .cell p p img {
  width: 50px !important;
}
</style>



// WEBPACK FOOTER //
// src/view/page/MallManage/PublicPlatoonGoods.vue